import { CTA } from '@components/ui'
import { useBrand } from '@contexts/index'
import { useEffect, useState } from 'react'

import Card from './card'
import Counter from './counter'
import Filter from './filter'

type Props = {
  models: Array<any>
  showFilter: boolean
  setModel: Function
  pricelist?: string
  type?: string
}

const ModelGrid = ({
  models,
  showFilter,
  setModel,
  pricelist,
  type = '',
}: Props) => {
  const [filtredModels, setFiltredModels] = useState(models)
  const [selectedModel, selectModel] = useState(false)
  const [isClient, setIsClient] = useState(false)
  const total = filtredModels.filter((model) => !model?.ui?.hidden).length
  const brand = useBrand()

  useEffect(() => {
    setIsClient(true)
  }, [])

  return (
    <div>
      {pricelist && (
        <div className="flex basis-full mb-8">
          <CTA
            href={pricelist}
            target="_blank"
            rel="noopener noreferrer"
            data-gt-name="ctaevent"
            data-gt-action="click-cta"
            data-gt-label={'View Pricelists'}
          >
            {brand === 'lexus' ? 'Download Pricelist' : 'View Pricelists'}
          </CTA>
        </div>
      )}

      <div className="flex flex-row flex-wrap pb-4 justify-between items-center md:justify-start">
        <Counter total={total} />
        {isClient && (
          <Filter
            showFilter={showFilter}
            models={models}
            filtredModelsCallBack={(vehicles) => {
              setFiltredModels(vehicles)
            }}
          />
        )}
      </div>
      <div className="grid grid-cols-1 gap-4 py-4 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-3 2xl:grid-cols-4">
        {isClient &&
          filtredModels.map((model, i) => (
            <Card
              type={type}
              key={model.rangecode + i}
              model={model}
              checkedModel={(vehicle) => selectModel(vehicle)}
              isChecked={selectedModel && selectedModel === model.rangecode}
              setModel={setModel}
            />
          ))}
      </div>
    </div>
  )
}

export default ModelGrid
